import { useSelector } from "react-redux";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const ExpertServices = () => {
  const selectedLanguages = useSelector(selectedLanguage);
 
  return (
    <section className="expert-services">
      <div className="expert-services__container container">
        <h2>{translations[selectedLanguages].expertServices.title}</h2>
        <p>{translations[selectedLanguages].expertServices.description}</p>
        <div className="expert-services__content">
          <div className="expert-services__content-item">
            <img src={Imgs.webImgfirst} alt="webimage" />
            <h3>
              {translations[selectedLanguages].expertServices.firstItemTitle}
            </h3>
            <p>
              {translations[selectedLanguages].expertServices.firstItemContext}
            </p>
          </div>
          <div className="expert-services__content-item">
            <img src={Imgs.webimgthird} alt="webimage" />
            <h3>
              {translations[selectedLanguages].expertServices.secondItemTitle}
            </h3>
            <p>
              {translations[selectedLanguages].expertServices.secondItemContext}
            </p>
          </div>
          <div className="expert-services__content-item">
            <img src={Imgs.webImgsecond} alt="webimage" />
            <h3>
              {translations[selectedLanguages].expertServices.thirdItemTitle}
            </h3>
            <p>
              {translations[selectedLanguages].expertServices.thirdItemContext}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertServices;
